var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.items.length > 0)?_c('div',{staticClass:"block-type-5"},[_c('BlockType2List',{attrs:{"data":_vm.blockType2data,"settings":_vm.settings}}),_vm._v(" "),_c('BlockType3List',{attrs:{"data":_vm.blockType3data,"settings":_vm.settings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }